// 根据环境引入不同配置 process.env.VUE_APP_ENV
var environment = process.env.VUE_APP_ENV || 'production';
var config = require('./env.' + environment);
module.exports = config;